/**
 * The date of the server
 * @author Ka Wing Chin <kawing.chin@takeaway.com>
 * @class ServerDateTime
 */

export default class ServerDateTime {
  /**
   * Current server date and time.
   * @property {moment}
   */
  time
  /**
   * Current day of the week according to the server
   * @property {int}
   */
  weekDay
  /**
   * Constructor
   * @param {moment} time the server time
   * @param {int} day week day
   */
  constructor (time, day) {
    this.time = time
    this.weekDay = day
  }
}
